import http from '@/utils/http/index';

export function queryMsgOperatorList(params) {
  return http.get('/payoutMerchant/listOperatorMsg', { params });
}

export function updateMsgOperatorList(data) {
  return http.post('/payoutMerchant/updateOperatorMsg', data);
}

export function queryMessageNotice() {
  return http.get('/payoutMerchant/msgProfile');
}

export function updateMessageNotice(params = {}) {
  return http.post(`/payoutMerchant/updateMsgProfile/${params.status}`);
}
